import React, { useState, useEffect } from 'react';
import { useAccountCrumbs } from '@thd-olt-component-react/customer-account-navigation';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import PageLayout from '../components/shared/PageLayout';
import SpendAcrossAccountElement from '../components/linked-accounts/SpendAcrossAccount';
import SpendByIndividualAccountElement from '../components/linked-accounts/SpendByIndividualAccount';
import { setLinkedAccountsPageAnalytics } from '../utils/linked-accounts/analytics';
export var LinkedAccounts = function (props) {
    var customerType = props.customerType, customerRole = props.customerRole;
    var _a = useState(''), hierarchyName = _a[0], setHierarchyName = _a[1];
    var crumbs = useAccountCrumbs([
        {
            label: 'Linked Accounts',
            path: '/myaccount/linked-accounts',
        },
    ]);
    useEffect(function () {
        setLinkedAccountsPageAnalytics();
    }, []);
    return (React.createElement(PageLayout, { crumbs: crumbs, pageTitle: "Linked Accounts", customerRole: customerRole, customerType: customerType, internalRoutes: ['/myaccount/linked-accounts'] },
        React.createElement("div", { className: "sui-max-w-[1039px]" },
            React.createElement(ErrorBoundary, { name: "spend-across-account" },
                React.createElement(SpendAcrossAccountElement, { hierarchyName: hierarchyName })),
            React.createElement(ErrorBoundary, { name: "spend-by-individual-account" },
                React.createElement(SpendByIndividualAccountElement, { setHierarchyName: setHierarchyName })))));
};
LinkedAccounts.displayName = 'Linked Accounts';
